import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface ICellRendererParamsForEqualizationRuleGridAction extends ICellRendererParams {
    viewDetails: (params: ICellRendererParamsForEqualizationRuleGridAction) => void;
}

@Component({
    selector: 'equalization-rule-list-grid-action-cell',
    template:
        `
        <button class="ace-btn btn-primary has-icon grid-action-button" (click)="onViewDetailsClicked()">
            <i class="fa fa-pencil"></i>
        </button>
        `,
    standalone: false
})
export class EqualizationRuleListGridActionCellRendererComponent implements ICellRendererAngularComp {
    equalizationRuleModel: Core.EqualizationRuleModel;

    private _params: ICellRendererParamsForEqualizationRuleGridAction;

    agInit(params: ICellRendererParamsForEqualizationRuleGridAction): void {
        this._params = params;
        this.equalizationRuleModel = params.data as Core.EqualizationRuleModel;
    }

    refresh(): boolean {
        return false; // tells grid to handle refreshing
    }

    onViewDetailsClicked(): void {
        this._params.viewDetails(this._params);
    }
}
